import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    chipContainer: {
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontFamily: "Inter",
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "18px",
      letterSpacing: "0.16px",
      display: "flex",
      minHeight: "24px",
      maxHeight: "24px",
      padding: "3px 4px",
      margin: "0px !important",
      alignItems: "center",
      width: "min-content",
      "& .MuiChip-icon": {
        order: 1,
        margin: 0,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      "& .MuiChip-label": {
        display: "flex",
        padding: "0 6px",
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
  };
});
